// extracted by mini-css-extract-plugin
module.exports = {"categoriesList":"CategoriesList_categoriesList__Nzky2","selectedListItem":"CategoriesList_selectedListItem__NTWoy"};